import AppStateManager from "@toothfairy/shared-ui/AppStateManager";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React, { useMemo } from "react";
import { View } from "react-native";
import ToothFairyButton from "../../../Components/ToothFairyComponents/ToothFairyButton";
import Constants from "../../../Constants";
import btnStyleGenerator from "../../../Constants/btnStyleGenerator";
import useWorkspaces from "../../../Hooks/useWorkspaces";
import { isLargeScreen, isVeryLargeScreen } from "../../MainViewContainer";

const AnswererActionButtons = ({
  handleParse,
  isParser,
  setIsModalOpen,
  isMainParsingFnDisabled,
  isPassageNil,
  data,
  isTopicModeOn,
  setOptionsModalOpen,
  setIsSaveOutputModalOpen,
  qValue,
  isAnswersEditorDirty,
  handleCancellation,
  answerInProgress,
  setReadyForNextQuestion,
  readyForNextQuestion,
  value,
  agentId,
}) => {
  const { currentTheme } = AppTheme.useTheme();
  const commonBtnStyle = useMemo(
    () => btnStyleGenerator.commonBtnStyleGenerator(currentTheme),
    [currentTheme]
  );
  const { state } = AppStateManager.useAppStateManager();
  const { isUserContentAdmin, handleGenerationOfCustomPrompt } =
    useWorkspaces();
  const _coreActionsButtons = useMemo(() => {
    return (
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          flex: 1,
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        {isParser && (
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginLeft: -10,
            }}
          >
            <ToothFairyButton
              {...commonBtnStyle}
              isDisabled={
                isMainParsingFnDisabled || isPassageNil || isAnswersEditorDirty
              }
              onPress={handleParse}
              title="Analyse"
            />
            {isLargeScreen() && Constants.isShowRequestEnabled && (
              <ToothFairyButton
                {...commonBtnStyle}
                isDisabled={
                  isMainParsingFnDisabled
                  // || !data || data?.length === 0
                }
                onPress={() => {
                  setIsModalOpen(true);
                }}
                title="Show Request"
              />
            )}
            {isLargeScreen() && answerInProgress && (
              <ToothFairyButton
                title={"Cancel"}
                onPress={() => {
                  handleCancellation();
                }}
                {...commonBtnStyle}
              />
            )}
            {isVeryLargeScreen() &&
              !answerInProgress &&
              isUserContentAdmin() && (
                <>
                  <ToothFairyButton
                    title={"Save output"}
                    onPress={() => {
                      setIsSaveOutputModalOpen(true);
                    }}
                    isDisabled={
                      (qValue[0]?.children?.length === 1 &&
                        qValue[0]?.children[0]?.text?.trim() === "") ||
                      isMainParsingFnDisabled
                    }
                    {...commonBtnStyle}
                  />
                  <ToothFairyButton
                    title={"Save prompt"}
                    onPress={() => {
                      handleGenerationOfCustomPrompt(value, [agentId]);
                    }}
                    isDisabled={
                      (value[0]?.children?.length === 1 &&
                        value[0]?.children[0]?.text?.trim() === "") ||
                      isMainParsingFnDisabled
                    }
                    {...commonBtnStyle}
                  />
                </>
              )}
            {isLargeScreen() &&
              isParser &&
              !readyForNextQuestion &&
              !answerInProgress && (
                <ToothFairyButton
                  {...commonBtnStyle}
                  title="Clear"
                  onPress={setReadyForNextQuestion}
                />
              )}
          </View>
        )}
        {!isLargeScreen() && (
          <ToothFairyButton
            isDisabled={
              isMainParsingFnDisabled
              // || !data || data?.length === 0
            }
            title="Options"
            {...commonBtnStyle}
            onPress={() => {
              setOptionsModalOpen(true);
            }}
          />
        )}
      </View>
    );
  }, [
    isMainParsingFnDisabled,
    isPassageNil,
    handleParse,
    data,
    isLargeScreen(),
    isParser,
    setIsModalOpen,
    isTopicModeOn,
    commonBtnStyle,
    readyForNextQuestion,
    answerInProgress,
  ]);
  return (
    <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
      {_coreActionsButtons}
    </View>
  );
};

export default AnswererActionButtons;
